import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {ThemeContext} from '../../common';
import Button from '../../common/Button';

const InteractiveNavigation = (props) => {
  const {
    modal,
    playerId,
    isAudiencePlayer,
    getCurrentUserId,
    startGameHandler,
    onVoteForKickClicked,
    onClearSelectedPlayer,
    onSendGiftClicked,
    chatToggleHandler,
  } = props;

  const theme = useContext(ThemeContext);
  const checkSelectedUser = () => {
    const currentUserId = getCurrentUserId();
    return playerId !== currentUserId;
  };

  let result;

  if (playerId && checkSelectedUser()) {
    result = (
      <div className="game__bottom-nav__expanded">
        {
          isAudiencePlayer ?
            <Button
              key="send-gift"
              className="button_expanded"
              bgColor={modal === 'gift' ? theme.primaryColor : theme.secondaryColor}
              handler={() => onSendGiftClicked(playerId)}
              text="Send Gift"
            /> : <Button
              key="send-gift"
              bgColor={modal === 'gift' ? theme.primaryColor : theme.secondaryColor}
              handler={() => onSendGiftClicked(playerId)}
              text="Send Gift"
            />
        }
        { isAudiencePlayer ? '' : <Button key="kick-player" bgColor={theme.secondaryColor} text="Kick Player" handler={() => onVoteForKickClicked(playerId)}/> }
        <Button key="back" bgColor={theme.secondaryColor} className="back" text="" handler={onClearSelectedPlayer}/>
      </div>
    );
  } else {
    result = (
      <div className="game__bottom-nav">
        <Button key="game" bgColor={theme.secondaryColor} className="game-btn" text="Game" handler={startGameHandler}/>
        <Button key="chat" bgColor={theme.secondaryColor} text="Chat" handler={chatToggleHandler}/>
      </div>
    );
  }

  return result;
};

InteractiveNavigation.propTypes = {
  modal: PropTypes.string,
  playerId: PropTypes.string,
  isAudiencePlayer: PropTypes.bool,
  getCurrentUserId: PropTypes.func.isRequired,
  chatToggleHandler: PropTypes.func.isRequired,
  startGameHandler: PropTypes.func.isRequired,
  onVoteForKickClicked: PropTypes.func.isRequired,
  onClearSelectedPlayer: PropTypes.func.isRequired,
  onSendGiftClicked: PropTypes.func.isRequired,
};

export default InteractiveNavigation;
